import {Component, inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogModule} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {NgClass} from '@angular/common';

@Component({
  selector: 'app-confirm-cancel-dialog',
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    NgClass
  ],
  templateUrl: './confirm-cancel-dialog.html',
  styleUrl: './confirm-cancel-dialog.scss',
})
export class ConfirmCancelDialog {
  protected readonly data = inject(MAT_DIALOG_DATA);
}
